import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger,
	keyframes
} from '@angular/animations';

/*export const routeAnimationTemplate = animation([
	group([
		query('router-outlet ~ :enter', [style({ transform: 'translate3d( {{ x }}, {{ y }}, 0px)', position: 'fixed', top: '0em'  })], 
			{ optional: true, params: {x: '100%', y: '0px'}  }),
		query(
			'router-outlet ~ :leave',
			[style({ transform: 'translate3d(0%, 0px, 0px)'}), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(-{{ x }}, 0px, 0px)' }))],
			{ optional: true }
		),
		query(
			'router-outlet ~ :enter',
			[style({ transform: 'translate3d( {{ x }}, {{ y }}, 0px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(0%, {{ y }}, 0px)'  }))],
			{ optional: true, params: {x: '0%', y: '0px'}  }
		),
		query('@*', [
        animateChild()
    ],
    	{ optional: true }
    )
	])
]);*/

export const routeAnimation = trigger('routeAnimation', [

	/*transition('* <=> *', [
		
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
	]),*/

	// index Up (right)
	transition(':increment', [

		group([
			query(':enter', [style({ transform: 'translate3d(100%, {{ y }}, 10px)', position: 'fixed' , height: '*', top: '0em', left: '0em' })]),
			query(':leave', [style({ transform: 'translate3d(0%, 0%, 0px)', position: 'relative' , height: '*', top: '0em', left: '0em' })]),
			query(
				':leave',
				[style({ transform: 'translate3d(0%, 0px, 0px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(-100%, 0px, 0px)'}))]
			),
			query(
				':enter',
				[style({ transform: 'translate3d(100%, {{ y }}, 10px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(0%, {{ y }}, 10px)'}))]
			)/*,
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )*/
		])	
	]),

	// index Down (left)
	transition(':decrement', [

		group([
			query(':enter', [style({ transform: 'translate3d(-100%, {{ y }}, 10px)', position: 'fixed', height: '*', top: '0em', left: '0em'  })]),
			query(':leave', [style({ transform: 'translate3d(0%, 0%, 0px)', position: 'relative', height: '*', top: '0em', left: '0em'  })]),
			query(
				':leave',
				[style({ transform: 'translate3d(0%, 0px, 0px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(100%, 0px, 0px)' }))]
			),
			query(
				':enter',
				[style({ transform: 'translate3d(-100%, {{ y }}, 10px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(0%, {{ y }}, 10px)'  }))]
			)/*,
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )*/
		])
	])
	
]);


export const slideOutAnimation = trigger('slideOutAnimation', [

	transition('-1 => *', [
		
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
	]),

	// index Up (right)
	transition(':increment', [

		group([
			query('router-outlet ~ :enter', [style({ transform: 'translate3d(10%, {{ y }}, 0px)', position: 'fixed'  })], 
				{ optional: true }
			),
			query(
				'router-outlet ~ :leave',
				[style({ transform: 'translate3d(0%, 0px, 10px)'}), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(-100%, 0px, 10px)' }))],
				{ optional: true }
			),
			query(
				'router-outlet ~ :enter',
				[style({ transform: 'translate3d(10%, {{ y }}, 0px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(0%, {{ y }}, 0px)'  }))],
				{ optional: true }
			),
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
		])	
	]),

	// index Down (left)
	transition(':decrement', [

		group([
			query('router-outlet ~ :enter', [style({ transform: 'translate3d(-100%, {{ y }}, 10px)', position: 'fixed'  })], 
				{ optional: true }
			),
			query(
				'router-outlet ~ :leave',
				[style({ transform: 'translate3d(0%, 0px, 0px)'}), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(10%, 0px, 0px)' }))],
				{ optional: true }
			),
			query(
				'router-outlet ~ :enter',
				[style({ transform: 'translate3d(-100%, {{ y }}, 10px)' }), animate('{{ animationDuration }} ease-in-out', style({ transform: 'translate3d(0%, {{ y }}, 10px)'  }))],
				{ optional: true }
			),
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
		])
	])
	
]);

export const pagerAnimation = trigger('pagerAnimation', [

	/*transition(':enter, * => 0, * => -1', []),
	transition(':increment', [

		query(':enter', [
				style({ transform: 'scale3d(0, 0, 0)' , position: 'absolute', opacity: 0}),
				animate('800ms ease-in-out', style({ transform: 'scale3d(1, 1, 1)' , position: 'absolute', opacity: 1}))
			],
			{ optional: true }),

			query(':leave', [
				style({ transform: 'scale3d(1, 1, 1)' , position: 'relative', opacity: 1}),
				animate('800ms 800ms ease-in-out', style({ transform: 'scale3d(0, 0, 0)' , position: 'absolute', opacity: 0}))
			],
	    { optional: true })

	])*/



	/*transition(':enter',[
		
		group([
			style({ opacity: 0}),
			animate('2000ms 2000ms', style({ opacity: 1})),
			animate('4000ms', keyframes([
				style({display: 'none', offset: 0}),
				style({display: 'inline-block', offset: 0.5})
			]))
		])
		
		
	]),

	guery(':leave',[
		group([
			style({ opacity: 1}),
			animate('2000ms 0ms', style({ opacity: 0})),
			animate('4000ms', keyframes([
				style({display: 'inline-block', offset: 0}),
				style({display: 'none', offset: 0.5})
			]))
		])
	])*/

	transition(':enter, * => 0, * => -1', []),
  transition('* <=> *', [
    query(':enter', [
      group([
				style({ opacity: 0}),
				animate('200ms 200ms', style({ opacity: 1})),
				animate('200ms', keyframes([
					style({display: 'none', offset: 0}),
					style({display: 'inline-block', offset: 1})
				]))
			])
    ], { optional: true }),
    query(':leave',[
			group([
				style({ opacity: 1}),
				animate('200ms 0ms', style({ opacity: 0})),
				animate('200ms', keyframes([
					style({display: 'inline-block', offset: 0}),
					style({display: 'none', offset: 1})
				]))
			])
		])
  ])
  

]);


export const holdHeightAnimation = trigger('holdHeightAnimation', [

  state( 'true', style({ height: '*' })),
  state( 'false', style({ height: 'auto' }))

]);
